import axios from "axios";

const API = "https://dywlf.com/api/paypal";

// kept in sync with PAYPAL_FEE_PERCENT in server/src/controllers/paypal.js
export const PAYPAL_FEE_PERCENT = 5;

export const getPaypalConfig = async () => {
  try {
    const { data } = await axios.get(`${API}/config`);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// creates the order on our server and returns the PayPal order id
export const createPaypalOrder = async (payload) => {
  try {
    const { data } = await axios.post(`${API}/createOrder`, payload);
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

export const capturePaypalOrder = async (orderId) => {
  try {
    const { data } = await axios.post(`${API}/captureOrder`, { orderId });
    return data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};
